import easyfyAxios from '@shared/easyfy.axios';

export const GetAgeGate = async (): Promise<any> => {
  return await easyfyAxios.get('/api/agegate');
};
